import styled from 'styled-components'

import { Link } from '@redriverpress/system'

const CollectionLink = styled(Link).attrs({
  reset: true,
  display: 'flex',
  flexDirection: 'column',
  p: 3,
  height: '100%',
  position: 'relative',
})`
  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: ${props => props.theme.radii.rounded};
    box-shadow: ${props => props.theme.shadows[2]};
    opacity: 0;
    transition: opacity 0.3s ease-out;
  }

  &:hover:after,
  &:focus:after {
    opacity: 1;
  }
`

export default CollectionLink
